import { render, staticRenderFns } from "./Resource_updata.vue?vue&type=template&id=52618238"
import script from "./Resource_updata.vue?vue&type=script&lang=js"
export * from "./Resource_updata.vue?vue&type=script&lang=js"
import style0 from "./Resource_updata.vue?vue&type=style&index=0&id=52618238&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports